import * as React from 'react';
import {InlineLabel} from '@mintdata/mint-kit/impl/properties/components/inlineLabel/InlineLabel';
import {BlockLabel} from '@mintdata/mint-kit/impl/properties/components/blockLabel/BlockLabel';
import {Tooltip} from '@mintdata/mint-kit/impl/components/tooltip/Tooltip';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';

const styles = require('@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/properties/widgets/common/PropertyBlockLabel.less');

export interface IPropertyBlockLabelProps
{
    label?:string | JSX.Element;
    description?:string;
}

export class PropertyBlockLabel extends React.Component<IPropertyBlockLabelProps>
{
    public render():JSX.Element
    {
        const {label, description} = this.props;

        if( !label ) return null;

        return (
            <BlockLabel>
                {
                    description &&
                    <Tooltip
                        content={description}
                        tooltipClassName={styles.tooltip}
                        popoverProps={{
                            sourceAnchor: SourceAnchor.LeftTop,
                            popupAnchor: PopupAnchor.LeftBottom,
                            className: styles.popover,
                        }}
                    >
                        {typeof label === 'string' ? <InlineLabel text={label} /> : label}
                    </Tooltip>
                }
                {
                    !description && (
                        typeof label === 'string' ? <InlineLabel text={label} /> : label
                    )
                }
            </BlockLabel>
        );
    }
}

